import { Component, EventEmitter, Input, Output } from '@angular/core'
import Pagination from '@ui/Pagination'
import ListItem, { DescriptionInput } from '@ui/ListItem'
import { ListItemAction } from '@ui/Components/List/ListItemAction.Component'
import {
	ListFilter,
	ListFilterComponent,
} from '@ui/Components/List/ListFilter.Component'
import {
	ListAction,
	ListActionComponent,
} from '@ui/Components/List/ListAction.Component'
import { SelectionModel } from '@angular/cdk/collections'
import QueryModifiers from '@ui/QueryModifiers'
import { Sortable } from '@ui/Sortable'
import { NgStyle } from '@angular/common'
import { PaginatorComponent } from '@ui/Components/Paginator/Paginator.Component'
import { CardComponent } from '@ui/Components/Card/Card.Component'
import { CardContentComponent } from '@ui/Components/Card/CardContent.Component'
import { QueryModifiersComponent } from '@ui/Components/QueryModifiers/QueryModifiers.Component'
import { ListItemComponent } from '@ui/Components/List/ListItem.Component'
import { CheckboxValueChange } from '@ui/Components/Table/Checkbox/TableCellCheckbox.Component'

@Component({
	selector: 'list-component',
	templateUrl: './List.Component.html',
	imports: [
		NgStyle,
		PaginatorComponent,
		CardComponent,
		CardContentComponent,
		ListFilterComponent,
		ListActionComponent,
		QueryModifiersComponent,
		ListItemComponent,
	],
})
export class ListComponent {
	@Input() public items: ListItem[]

	@Input() public paginator: Pagination

	@Input() public queryModifiers: QueryModifiers

	@Input() public model: Sortable

	@Input() public itemTracker: (index: number, item: ListItem) => number

	@Input() public setPaginator: (paginator: Pagination) => void

	@Input() public setQueryModifiers: (queryModifiers: QueryModifiers) => void

	@Input() public requesting: boolean

	@Input() public actions: ListAction[]

	@Input() public itemActions: ListItemAction[]

	@Input() public filters: ListFilter<any>[]

	@Input() public totalIcon: string

	@Input() public descriptionParams: DescriptionInput = {}

	@Input() public deleteSelection: SelectionModel<ListItem>

	@Output() private readonly deleteSelectionChecked =
		new EventEmitter<CheckboxValueChange>()

	public filterTracker = (index: number): number => index

	public actionTracker = (index: number): number => index

	public handleToggle = (event: CheckboxValueChange) => {
		this.deleteSelectionChecked.emit(event)
	}
}
